import React, { useEffect, useState } from 'react'
import { SubmissionError } from 'redux-form'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { runAction } from '../../../utils/api'
import { uniqueElements } from '../../../utils/arrays'
import { getAction, fetchAction } from '../../../ducks/actions'
import { fetchDatabases } from '../../../ducks/databases'
import { getCurrentOrganizationId } from '../../../ducks/users'
import Form from './Form'
import { FullScreenLoader } from '../../Shared/Loading'
import Button from '../../Shared/Button'
import Card from '../../Shared/Card'
import EmptyState from '../../Shared/EmptyState'

const styles = require('./Run.module.css')

export const RunAction = function RunAction({
  actionId,
  presetValues,
  doneRedirect,
  doneRedirectReplaceState,
}) {
  const [done, setDone] = useState(false)
  const history = useHistory()
  const dispatch = useDispatch()
  const action = useSelector(getAction(actionId))
  const orgId = useSelector(getCurrentOrganizationId)

  useEffect(() => {
    dispatch(fetchAction(actionId))
  }, [dispatch, actionId])

  useEffect(() => {
    dispatch(fetchDatabases(orgId))
  }, [dispatch, orgId])

  const handleSubmit = async data => {
    try {
      data = { ...data, ...presetValues }

      // Remove react-select values
      for (let key of Object.keys(data)) {
        data[key] = data[key].value || data[key]
      }

      await runAction(actionId, data)

      setDone(true)
    } catch (err) {
      if (err.response && err.response.status === 400) {
        let response = err.response.data

        if (!Array.isArray(response)) {
          response = [response]
        }

        const errors = uniqueElements(
          response
            .map(itm => itm.error && itm.error.humanReadableError)
            .filter(itm => itm)
        )

        const firstError = errors[0]

        if (firstError) {
          throw new SubmissionError({ _error: `Error: ${firstError}` })
        }
      }

      throw new SubmissionError({ _error: 'An unknown error occurred.' })
    }
  }

  const handleRunAgain = () => {
    setDone(false)
  }

  if (!action) {
    return <FullScreenLoader />
  }

  if (action && !action.details) {
    return (
      <EmptyState>
        <h2>Action has no steps.</h2>
        <Button to={`/actions/${actionId}/configure`}>Edit Action</Button>
      </EmptyState>
    )
  }

  if (done) {
    return (
      <Card
        actions={
          <>
            <Button text onClick={handleRunAgain}>
              Run Again
            </Button>
            <Button
              color="grey"
              to={doneRedirect || '/'}
              replace={doneRedirectReplaceState}
            >
              Done
            </Button>
          </>
        }
      >
        <h1>{action.name}</h1>
        <div className={styles.success}>
          <div className={styles.checkmark} />
          <h1>Success!</h1>
        </div>
      </Card>
    )
  }

  return (
    <Form
      onSubmit={handleSubmit}
      action={action}
      history={history}
      presetValues={presetValues}
    />
  )
}

export default function RunActionWrapper({ match }) {
  const { id: actionId } = match.params

  return <RunAction actionId={actionId} />
}
